import { Component, Input, OnChanges, SimpleChanges } from '@angular/core'
import { ChartConfiguration } from 'chart.js'
import { SmartLink } from '../../../shared/interfaces/smart-link.interface'

import { AggregationDataset } from '../../../shared/interfaces/visualizations/aggregation-dataset.interface'
import { ColorService } from '../../../shared/services/color.service'
import { SmartLinkService } from '../../../shared/services/smart-link.service'
import ChartDataLabels from 'chartjs-plugin-datalabels'

@Component({
  selector: 'app-scatter-plot',
  templateUrl: './scatter-plot.component.html',
  styleUrls: ['./scatter-plot.component.scss']
})
export class ScatterPlotComponent implements OnChanges {
  @Input() dataset: AggregationDataset

  chartData: ChartConfiguration<'scatter'>['data']
  // We use "any" instead of ChartDataset<'bar', any>[] to attach "link" to the dataset.
  datasets: any[]

  chartPlugins = [ChartDataLabels]

  chartOptions: any = {
    responsive: true,
    elements: {
      point: {
        radius: 6
      }
    },
    plugins: {
      datalabels: {
        anchor: 'center',
        align: 'right',
        offset: 4,
        formatter: (_value: any, context: any) => ''
          // this.dataset.data[context.dataIndex].uri
      },
      tooltip: {
        mode: 'index',
        callbacks: {
          title: () => '',
          label: (context: any) => context.label
        },
        displayColors: false
      }
    },
    scales: {
      x: {
        grid: {
          lineWidth: (context: any) => (context.tick.value === 0 ? 3 : 1)
        },
        title: {
          display: true
        }
      },

      y: {
        grid: {
          lineWidth: (context: any) => (context.tick.value === 0 ? 3 : 1)
        },
        title: {
          display: true
        }
      }
    }
  }

  colors: string[] = ColorService.getColors()

  constructor(private smartLinkService: SmartLinkService) {}

  ngOnChanges(): void {
    this.chartOptions.scales.x.title.text = this.dataset.xAxisLabel
    this.chartOptions.scales.y.title.text = this.dataset.yAxisLabel

    this.datasets = [
      {
        label: 'Incentive similarity',
        data: this.dataset.data.map((d) => ({
          x: d.valueX,
          y: d.valueY
        })),
        backgroundColor: '#68caff',
        links: this.dataset.data.map((d) => d.link)
      }
    ]

    this.chartData = {
      labels: this.dataset.data.map((d) => d.label),
      datasets: this.datasets
    }
  }

  onChartClick(event: any) {
    const clickedElement = event.active[0]
    if (!clickedElement) {
      return
    }
    const link: SmartLink =
      this.datasets[clickedElement.datasetIndex].links[clickedElement.index]

    if (link) {
      this.smartLinkService.goToLink(link)
    }
  }
}
